module.exports = "https://static.wanderu.com/ui-react/_next/static/media/ie.1b0ac4e7.svg";